/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { IQueryParam, ITime, ITimeSerialized } from ".";
import { Timestamp } from "@google-cloud/firestore";

export module AccessPeriodDataModel {
    export const MaxTimestamp: number = 253402297199999; // 9999-12-31T23:59:59.999999999

    export interface IAccessPeriod {
        id: string;
        contractId: string;
        userId: string;
        projectId: string;
        startDate: Timestamp;
        endDate: Timestamp;
        time: ITime;
    }

    export interface IAccessPeriodSerialized {
        id: string;
        contractId: string;
        userId: string;
        projectId: string;
        startDate: number;
        endDate: number;
        time: ITimeSerialized;
    }

    export interface IAccessIdsAccessPeriodsMapping {
        [accessId: string]: IAccessPeriod;
    }

    export module Database {
        export interface ICreateInfo {
            contractId: string;
            userId: string;
            projectId: string;
            startDate: Timestamp;
            endDate: Timestamp;
            accessPeriodId?: string;
        }

        export interface IDeleteInfo {
            contractId: string;
            accessPeriodId: string;
        }
        export interface IGetInfo {
            contractId: string;
            accessPeriodId: string;
        }
        export interface IQueryInfo {
            contractId: string;
            queryParam: IQueryParam;
        }
        export interface IUpdateInfo {
            contractId: string;
            accessPeriodId: string;
            endDate: Timestamp;
        }
    }
}
